module.exports = __webpack_public_path__ + "static/assets/886a8dff65cbbdb2fbf11f6b227b4f2c.svg";